import { AxiosError } from 'axios'
import { toast } from 'sonner'

export function handleServerError(error: unknown) {
  let errMsg = 'Bir şeyler yanlış gitti!'

  if (error instanceof AxiosError) {
    const data = error.response?.data

    // Check for express-validator errors array
    if (data?.errors && Array.isArray(data.errors)) {
      errMsg = data.errors.map((e: any) => e.msg).join(', ')
    }
    // Check for custom message field
    else if (data?.message) {
      errMsg = data.message
    }
    // Check for title field (common in some frameworks)
    else if (data?.title) {
      errMsg = data.title
    }
  }

  toast.error(errMsg)
}
